module.exports = fox._r("images/_banner-cam.png", __webpack_public_path__ + "images/_banner-cam.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/_banner-cam.png
// module id = 961
// module chunks = 4